var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 72,
    viewBox: "0 0 68 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1055 14.7467C16.64 14.7467 16.2633 14.37 16.2633 13.9044C16.2633 11.8464 14.5902 10.1734 12.5331 10.1734C12.0675 10.1734 11.6908 9.7967 11.6908 9.33114C11.6908 8.86559 12.0675 8.48887 12.5331 8.48887C14.5902 8.48887 16.2633 6.81584 16.2633 4.75951C16.2633 4.29396 16.64 3.91724 17.1055 3.91724C17.5711 3.91724 17.9478 4.29395 17.9478 4.75951C17.9478 6.81584 19.6217 8.48887 21.6788 8.48887C22.1444 8.48887 22.5211 8.86559 22.5211 9.33114C22.5211 9.7967 22.1444 10.1734 21.6788 10.1734C19.6217 10.1734 17.9478 11.8464 17.9478 13.9044C17.9478 14.37 17.5711 14.7467 17.1055 14.7467Z",
    fill: "#D9102A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M62.3256 30.2571C61.8601 30.2571 61.4833 29.8804 61.4833 29.4148C61.4833 27.3568 59.8103 25.6838 57.7532 25.6838C57.2876 25.6838 56.9109 25.3071 56.9109 24.8415C56.9109 24.376 57.2876 23.9993 57.7532 23.9993C59.8103 23.9993 61.4833 22.3262 61.4833 20.2699C61.4833 19.8043 61.8601 19.4276 62.3256 19.4276C62.7912 19.4276 63.1679 19.8043 63.1679 20.2699C63.1679 22.3262 64.8418 23.9993 66.8989 23.9993C67.3645 23.9993 67.7412 24.376 67.7412 24.8415C67.7412 25.3071 67.3645 25.6838 66.8989 25.6838C64.8418 25.6838 63.1679 27.3568 63.1679 29.4148C63.1679 29.8804 62.7912 30.2571 62.3256 30.2571Z",
    fill: "#D9102A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.67356 42.6927C5.20801 42.6927 4.83131 42.316 4.83131 41.8505C4.83131 39.7941 3.15826 38.1211 1.1011 38.1211C0.635553 38.1211 0.25885 37.7444 0.25885 37.2788C0.25885 36.8133 0.635546 36.4366 1.1011 36.4366C3.15826 36.4366 4.83131 34.7635 4.83131 32.7056C4.83131 32.24 5.208 31.8633 5.67356 31.8633C6.13912 31.8633 6.51586 32.24 6.51586 32.7056C6.51586 34.7635 8.18886 36.4366 10.246 36.4366C10.7116 36.4366 11.0883 36.8133 11.0883 37.2788C11.0883 37.7444 10.7116 38.1211 10.246 38.1211C8.18886 38.1211 6.51586 39.7941 6.51586 41.8505C6.51586 42.316 6.13912 42.6927 5.67356 42.6927Z",
    fill: "#D9102A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.9869 4.65107C40.9408 4.8817 40.91 5.12753 40.91 5.37354V23.4132L37.4742 21.2458L34.638 7.2799L34.3843 6.04233C34.3382 5.8194 34.3153 5.59647 34.3153 5.37354C34.3153 3.80569 35.422 2.39135 37.0209 2.0684C38.827 1.69947 40.6026 2.86029 40.9869 4.65106V4.65107Z",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.4743 21.246L33.316 18.6173L30.7411 11.7533C30.5951 11.369 30.5258 10.9693 30.5258 10.5773C30.5258 9.20912 31.3637 7.91018 32.7165 7.41064C33.3545 7.17232 34.0154 7.14155 34.638 7.28004L37.4743 21.246V21.246Z",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.7895 54.5889V54.2356",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.6574 24.3066V5.37535C47.6574 3.51514 46.1355 2.00098 44.283 2.00098C43.353 2.00098 42.5074 2.3776 41.9002 2.99254C41.4468 3.4384 41.124 4.00717 40.9856 4.65289C40.9394 4.88333 40.9088 5.12934 40.9088 5.37535V23.415L37.4731 21.2475L33.3147 18.6188L32.3616 18.0192L23.2994 23.6532C22.0313 24.4372 21.2549 25.8285 21.2549 27.3195V30.0713C19.0029 29.979 17.1812 31.7853 17.1812 33.9606C17.1812 34.0835 17.1812 34.2064 17.1965 34.3295C17.4962 37.4502 18.5032 41.8083 21.5469 45.713C24.7445 49.825 27.7883 51.2701 27.7883 51.2701V54.2369C27.9573 54.2061 28.1264 54.1908 28.3032 54.1908H46.3506C46.5044 54.1908 46.6504 54.2062 46.7964 54.2294C47.8878 48.6415 47.6573 24.3066 47.6573 24.3066H47.6574ZM38.1032 38.7799L30.5015 41.4163C30.5015 41.4163 27.3963 39.5254 25.4978 36.0435C25.1519 35.4132 24.9828 34.6908 24.9828 33.9683C24.9828 33.7761 24.8215 32.5616 24.9367 33.4149C26.9658 32.6924 28.4186 30.7476 28.4186 28.465L30.5015 26.8046H33.0609L36.3276 28.4111L39.5789 32.7078L38.1032 38.7799V38.7799Z",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M46.7977 54.2278C46.7746 54.3583 46.7439 54.4812 46.7208 54.5888",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M49.3343 57.1716V67.0176C49.3343 68.6625 47.9892 70 46.3519 70H28.3045C26.6673 70 25.3299 68.6625 25.3299 67.0176V57.1716C25.3299 55.7036 26.3984 54.4814 27.7894 54.2354C27.9587 54.2046 28.1278 54.1892 28.3045 54.1892H46.3519C46.5056 54.1892 46.6516 54.2046 46.7976 54.2277C48.2273 54.4429 49.3343 55.6803 49.3343 57.1716H49.3343Z",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M21.2549 30.0713H21.5516C23.3982 30.0713 24.8952 31.5683 24.8952 33.4149",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.0d8948ef84c3824993c8e33ae9d1d59a.svg";
export { ForwardRef as ReactComponent };